module.exports = __webpack_public_path__ + "assets/icons/is-deprecated.svg?fd4d60";


//////////////////
// WEBPACK FOOTER
// ../xod-client/src/core/assets/icons/is-deprecated.svg
// module id = 957
// module chunks = 0